import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import {
  type SocietyProfileInvoiceBodyInput,
  type SocietyProfileInvoiceDeleteBodyInput,
} from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice";
import { type SocietyProfileInvoiceParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/index";
import { type InvoiceView } from "shared/mappers/database/accounting/invoice/invoice";
export const getSocietyProfileAccountingInvoiceIdContract: BaseApiContract<
  SocietyProfileInvoiceParamsInput,
  undefined,
  InvoiceView
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]",
  paramsType: {} as SocietyProfileInvoiceParamsInput,
  responseType: {} as InvoiceView,
};
export const postSocietyProfileAccountingInvoiceIdContract: BaseApiContract<
  SocietyProfileInvoiceParamsInput,
  SocietyProfileInvoiceBodyInput,
  InvoiceView
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]",
  paramsType: {} as SocietyProfileInvoiceParamsInput,
  bodyType: {} as SocietyProfileInvoiceBodyInput,
  responseType: {} as InvoiceView,
};
export const deleteSocietyProfileAccountingInvoiceIdContract: BaseApiContract<
  SocietyProfileInvoiceParamsInput,
  SocietyProfileInvoiceDeleteBodyInput,
  void
> = {
  method: HttpMethod.DELETE,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]",
  paramsType: {} as SocietyProfileInvoiceParamsInput,
  bodyType: {} as SocietyProfileInvoiceDeleteBodyInput,
  responseType: undefined as unknown as void,
};
